
			if ('serviceWorker' in navigator) {
				window.addEventListener('load', () => {
					navigator
						.serviceWorker
						.register('/assets/js/sw.js')
				})
			}
		